import styled from 'styled-components'

export const CVGeneratorContainer = styled.div`
  width: 100%;
  margin-top: 7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`
